<template>
    <div v-if="!$route.meta.noSearch" class="flex-between-center header-search-view el-no-border">
        <el-select v-model="searchType" placeholder="请选择" class="fb-16 primary-selected">
            <el-option v-for="item in options" :key="item[optionConfig.CODE]" :label="item[optionConfig.LABEL]" :value="item[optionConfig.CODE]" />
        </el-select>
        <el-input v-model="searchValue" placeholder="请输入关键字搜索..." class="fb-16" />
        <!-- <el-button type="primary" :icon="ElIconSearch" class="fill-h my-search-btn" @click="search" /> -->
		<el-icon class="el-icon--right"><Upload /></el-icon>
    </div>
</template>
<script>
    // import { Search as ElIconSearch } from '@element-plus/icons'
    // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    // 例如：import 《组件名称》 from '《组件路径》';
    // 例如：import uploadFile from '@/components/uploadFile/uploadFile'

    import {
        SEARCH_INPUT_OPTIONS_TYPES,
        SELECT_OPTION_CONFIG,
    } from '@/utils/constant'

    export default {
        data() {
            return {
                searchType: SEARCH_INPUT_OPTIONS_TYPES.PROJECT_NAME[SELECT_OPTION_CONFIG.CODE],
                searchValue: '',
                options: Object.values(SEARCH_INPUT_OPTIONS_TYPES),
                optionConfig: SELECT_OPTION_CONFIG,
                // ElIconSearch,
            }
        },
        name: 'HeadSearch',
        // import引入的组件需要注入到对象中才能使用
        components: {},
        props: {
            // patientIn: {
            //   type: Object,
            //   default () {
            //     return {}
            //   }
            // }
        },
        // 监听属性 类似于data概念
        computed: {},
        // 生命周期 - 创建完成（可以访问当前this实例）
        created() {},
        // 生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {},
        // 方法集合
        methods: {
            search() {
                const type = this.searchType
                const keyword = this.searchValue
                this.searchType =
                    SEARCH_INPUT_OPTIONS_TYPES.PROJECT_NAME[SELECT_OPTION_CONFIG.CODE]
                this.searchValue = ''
                this.$router.push({
                    path: `/purchase/list/${this.MENU_ID.PURCHASE}`,
                    query: {
                        type,
                        [type]: keyword,
                    },
                })
            },
        },
    }
</script>
<style lang="scss" scoped>
    .header-search-view {
        width: 472px;
        height: 48px;
        background-color: #f9f9f9;
    }
    .my-search-btn {
        width: 88px;
        font-size: 26px;
        padding: 0;
        flex-shrink: 0;
    }
</style>